import { gql } from '@apollo/client';

export const SCANNER_BROKEN_LINKS = gql`
  mutation scannerBrokenLinks($domain: String!, $siteId: String!) {
    scannerBrokenLinks(domain: $domain, siteId: $siteId)
  }
`;

export const COMPLIANCE_BROKEN_LINKS = gql`
  query complianceBrokenLinks($domain: String!, $page: Float!, $limit: Float!) {
    complianceBrokenLinks(domain: $domain, page: $page, limit: $limit) {
      total
      urls {
        url
        postURL
        status
      }
    }
  }
`;
